import { __decorate } from "tslib";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
// @ts-ignore
import Employee from "@/classes/Employee";
import EmployeeCollectionAdmin from "@/classes/EmployeeCollectionAdmin";
import ReportCollection from "@/classes/ReportCollection";
import IconBox from "@/components/IconBox.vue";
import IconBoxContent from "@/components/IconBoxContent.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import Datepicker from "vuejs-datepicker";
let AdminDetailsView = class AdminDetailsView extends Vue {
    loadAdminTimeReports() {
        this.$data.loading = true;
        this.$store
            .dispatch("loadAdminTimeReportsAsync", {
            date: this.$store.getters.getSelectedDate,
        })
            .then((result) => {
            const tempReports = new ReportCollection();
            tempReports.importReportObjectsFromJson(result.data);
            this.$data.reports = tempReports.getReportsForEmployeeMonth(this.$route.params.user);
            this.$data.loading = false;
        })
            .catch((err) => {
            window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            this.$data.loading = false;
        });
    }
    //loads the employees as an admin
    loadAdminEmployees() {
        this.$store
            .dispatch("adminLoadEmployees")
            .then((result) => {
            this.$store.commit("setGlobalEmployeesAdmin", result.data);
            this.$data.employees = new EmployeeCollectionAdmin(result.data);
            const fullName = this.$data.employees.getEmployee(this.$route.params.user)[0].employeeFullName;
            this.$data.employeeName = fullName;
            //once we have the users we load the reports (we need the users to be able to calculate the total)
            this.$store
                .dispatch("loadAdminTimeReportsAsync", {
                date: this.$store.getters.getSelectedDate,
            })
                .then((result2) => {
                const tempReports = new ReportCollection();
                tempReports.importReportObjectsFromJson(result2.data);
                this.$data.reports = tempReports.getReportsForEmployeeMonth(this.$route.params.user);
                this.$data.preloaded = true;
            })
                .catch((err) => {
                this.$data.preloaded = true;
                window.errorHandler.logError(err, "UserHours.vue -> loadAdminEmployees -> loadAdminTimeReportsAsync");
            });
        })
            .catch((err) => {
            this.$data.preloaded = true;
            window.errorHandler.logError(err, "UserHours.vue - loadAdminEmployees");
        });
    }
    // function that loads the holidays data object from the store. Loads locally if available API otherwise.
    loadHolidayData() {
        this.$data.holidays = this.$store.getters.getHolidays;
        if (this.$store.getters.getHolidays === null) {
            const currentYear = moment(this.$store.getters.getSelectedDate).format("YYYY");
            this.$store
                .dispatch("loadHolidaysAsync", { year: currentYear })
                .then((holidays) => {
                this.$store.commit("setHolidays", {
                    data: holidays.data,
                    year: currentYear,
                });
                this.$data.holidays = holidays.data;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "UserDetailsView.vue - loadHolidayData");
            });
        }
    }
    impersonateUser() {
        const impersonateUser = new Employee(this.$data.impersonationObject[0]);
        this.$store.dispatch("impersonateUser", impersonateUser);
        this.$store
            .dispatch("validateEmployeeAsync")
            .then((response) => {
            const employeeReturn = response.data;
            this.$store.commit("setLoggedInUser", employeeReturn);
        })
            .catch((error) => {
            console.log(error);
        });
    }
    calculateMonthTime() {
        const selectedDate = this.$store.getters.getSelectedDate;
        const start = window.dateHandler
            .getStartOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const end = window.dateHandler
            .getEndOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const filtered = this.$data.reports.filter((report) => {
            return (moment(report.date).format("YYYY-MM-DD") >= start &&
                end >= moment(report.date).format("YYYY-MM-DD"));
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    calculateMonthTimeForTariff(tariffId) {
        const selectedDate = this.$store.getters.getSelectedDate;
        const start = window.dateHandler
            .getStartOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const end = window.dateHandler
            .getEndOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const filtered = this.$data.reports.filter((report) => {
            return (moment(report.date).format("YYYY-MM-DD") >= start &&
                end >= moment(report.date).format("YYYY-MM-DD") &&
                report.tariffId === tariffId);
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    calculateMonthBillable() {
        const selectedDate = this.$store.getters.getSelectedDate;
        const start = window.dateHandler
            .getStartOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const end = window.dateHandler
            .getEndOfMonth(selectedDate)
            .format("YYYY-MM-DD");
        const filtered = this.$data.reports.filter((report) => {
            return (moment(report.date).format("YYYY-MM-DD") >= start &&
                end >= moment(report.date).format("YYYY-MM-DD") &&
                report.billable === true);
        });
        let totalHours = 0;
        filtered.forEach((report) => {
            totalHours += Number(report.hours);
        });
        //this.monthHours = totalHours;
        return totalHours;
    }
    getReportsForTariff(tariffId) {
        return this.$data.reports.filter((report) => {
            return report.tariffId === tariffId;
        });
    }
    getTariffIds() {
        const temp = [...new Set(this.$data.reports.map((x) => x.tariffId))];
        temp.sort((a, b) => (a > b ? 1 : -1));
        return temp;
    }
    getWeek(date) {
        return window.dateHandler.getWeekNumber(date);
    }
    shortDate(date) {
        return moment(date).format("YYYY-MM-DD");
    }
    dateToDay(date) {
        return moment(date).format("ddd");
    }
    calculateAvailableHours() {
        const start = window.dateHandler
            .getStartOfMonth(this.$store.getters.getSelectedDate)
            .format("YYYY-MM-DD");
        let totalHours = 0;
        for (let i = 0; i < moment(start).daysInMonth(); i++) {
            const date = window.dateHandler.addDays(start, i);
            if (this.isNonWorkingDay(date) === false) {
                totalHours += 8;
            }
        }
        return totalHours;
    }
    isNonWorkingDay(date) {
        const holidayColl = this.$data.holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(date).isoWeekday() === 6 ||
            moment(date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    selectPreviousMonth() {
        const newDate = window.dateHandler
            .subtractMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
        this.$data.loading = true;
    }
    selectNextMonth() {
        const newDate = window.dateHandler
            .addMonths(this.$store.getters.getSelectedDate, 1)
            .startOf("month")
            .format("YYYY-MM-DD");
        this.$store.commit("setSelectedDate", { date: newDate });
        this.loadAdminTimeReports();
        this.getDateInfo();
        this.$data.loading = true;
    }
    getDateInfo() {
        this.$data.dateInfo = this.$store.getters.getDateInfo;
    }
};
AdminDetailsView = __decorate([
    Component({
        data() {
            return {
                fetchingData: false,
                theme: this.$store.getters.getTheme,
                dateInfo: {
                    year: 0,
                    month: null,
                    week: 0,
                    weekHours: 0,
                    monthHours: 0,
                },
                reports: null,
                selectedDate: this.$store.getters.getSelectedDate,
                availableHours: 0,
                holidays: null,
                tariffs: this.$store.getters.getGlobalTariffs,
                employees: null,
                employeeName: "",
                userReports: null,
                hoursArray: null,
                totalHours: 0,
                filter: "",
                headers: [
                    { text: "Week", value: "week", width: "15%", align: "left" },
                    { text: "Day", value: "day", width: "15%", align: "left" },
                    { text: "Date", value: "date", width: "15%", align: "left" },
                    { text: "Hours", value: "hours", width: "15%", align: "left" },
                    { text: "Comment", value: "comment", width: "55%", align: "left" },
                ],
                impersonationObject: null,
                loading: false,
                preloaded: false,
            };
        },
        mounted() {
            this.$store.commit("setSelectedDate", {
                date: this.$store.getters.getSelectedDate,
            });
            this.loadAdminEmployees();
            this.$data.fetchingData = true;
            this.getDateInfo();
            this.loadHolidayData();
            window.eventBus.$on("adminReportsUpdated", () => {
                const temp = this.$store.getters.getAdminReports;
                this.$data.reports = temp.getReportsForEmployeeMonth(this.$route.params.user);
                this.$data.fetchingData = false;
            });
            // loading the employee list
            window.eventBus.$on("employeesAdminLoaded", (obj) => {
                const emps = obj.filter((object) => object.userId === this.$route.params.user);
                this.$data.impersonationObject = emps;
            });
        },
        components: {
            IconBox,
            IconBoxContent,
            WhiteBox,
            Datepicker,
        },
    })
], AdminDetailsView);
export default AdminDetailsView;
